module.exports = "/legacy/9ac52b2722342b480c7ba8b7f1a8af8f.png";